import { render, staticRenderFns } from "./organizationManage.vue?vue&type=template&id=07478458&scoped=true"
import script from "./organizationManage.vue?vue&type=script&lang=js"
export * from "./organizationManage.vue?vue&type=script&lang=js"
import style0 from "./organizationManage.vue?vue&type=style&index=0&id=07478458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07478458",
  null
  
)

export default component.exports